import React from "react";
import {
  Box,
  Typography,
  Link,
  Grid,
  Divider,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  Facebook,
  Twitter,
  Instagram,
  Place,
  Email,
  Phone,
  Business,
} from "@material-ui/icons";

import Centrika from "../../assets/img/logo.png";

const year = new Date().getFullYear();

const useStyles = makeStyles((theme) => ({
  foot: {
    height: "auto",
    width: "100%",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.secondary.main,
    marginTop: 100,
    padding: 20,
  },
  divider: {
    marginTop: 10,
    marginBottom: 10,
  },
  f: {
    display: "flex",
    flexDirection: "column",
  },
  button: {
    color: "#fff",
    textTransform: "none",
    alignText: "left",
    cursor: "pointer",
  },
  arrow: {
    marginRight: 5,
    fontSize: 16,
  },
  holder: {
    marginTop: 7,
    display: "flex",
    alignItems: "center",
  },
  a: {
    textDecoration: "none",
    color: "#e6ebf0",
  },
  cent: {
    height: 35,
    marginTop: 7,
    marginLeft: 5,
  },
}));

function Footer(props) {
  const classes = useStyles();
  return (
    <Box className={classes.foot}>
      <Grid container justifyContent="center" alignItems="center" spacing={3}>
        <Grid item xs={12} sm={12} md={3}>
          <Box ml={5}>
            <Typography variant="h5" color="primary" align="left" gutterBottom>
              Powered by
            </Typography>
            <img src={Centrika} alt="Centrika logo" height={80} />
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={5}>
          <Typography variant="h5" color="primary" align="left" gutterBottom>
            Centrika
          </Typography>
          <Typography component="p" style={{ color: "#e6ebf0" }}>
          Centrika Ltd , a fintech and software development company,focused on improving technology solutions and human resources to deliver tomorrow's solutions today.
          </Typography>
        </Grid>

        <Grid item xs={1}></Grid>
        <Grid item xs={12} sm={12} md={3} className={classes.f}>
          <Typography variant="h5" color="primary" gutterBottom>
            Our contacts
          </Typography>
          <div className={classes.holder}>
            <Place color="primary" className={classes.arrow} />{" "}
            <Link
              onClick={() =>
                window.open(
                  "https://www.google.com/maps/place/Centrika+Rwanda/@-1.9422332,30.0560463,17z/data=!3m1!4b1!4m5!3m4!1s0x19dca57ab4ab7b39:0x68557a851cd5b392!8m2!3d-1.9422332!4d30.058235",
                  "_blank"
                )
              }
              className={classes.button}
              size="small"
              color="secondary"
            >
              KN 2,Plot 1007,2nd Floor - Room F42A
            </Link>
          </div>
          <div className={classes.holder}>
            <Business color="primary" className={classes.arrow} />
            <Link
              onClick={() =>
                window.open(
                  "https://www.google.com/maps/place/Centrika+Rwanda/@-1.9422332,30.0560463,17z/data=!3m1!4b1!4m5!3m4!1s0x19dca57ab4ab7b39:0x68557a851cd5b392!8m2!3d-1.9422332!4d30.058235",
                  "_blank"
                )
              }
              className={classes.button}
              size="small"
              color="secondary"
            >
              CHIC Building Kigali-Rwanda
            </Link>
          </div>
          <div className={classes.holder}>
            <Email color="primary" className={classes.arrow} />
            <Link
              onClick={() =>
                window.open(
                  "mailto:support@safaribus.rw?subject=Subject&body=message%20goes%20here",
                  "_blank"
                )
              }
              className={classes.button}
              size="small"
              color="textSecondary"
            >
              support@safaribus.rw
            </Link>
          </div>
          <div className={classes.holder}>
            <Phone color="primary" className={classes.arrow} />
            <Link
              onClick={() => window.open("tel://+250 731-000-100", "_blank")}
              className={classes.button}
              size="small"
              color="inherit"
            >
              2838
            </Link>
          </div>
        </Grid>
      </Grid>

      <Divider light={true} className={classes.divider} />

      <Grid container justify="center" spacing={3}>
        <Grid item xs={12} sm={12} md={5}>
          <Typography
            variant="body1"
            gutterBottom
            style={{ color: "#fff", marginTop: 5 }}
          >
            Copyright@{year} Centrika All Right Reserved
          </Typography>
        </Grid>

        <Grid item xs={12} sm={12} md={4}>
          <div style={{ display: "flex", marginLeft: 12 }}>
            <IconButton
              color="primary"
              onClick={() =>
                window.open(
                  "https://www.facebook.com/Centrika-Rwanda-435139043999902/posts",
                  "_blank"
                )
              }
            >
              <Facebook />
            </IconButton>
            <IconButton
              color="primary"
              onClick={() =>
                window.open("https://twitter.com/centrikarw?lang=en", "_blank")
              }
            >
              <Twitter />
            </IconButton>
            <IconButton
              color="primary"
              onClick={() =>
                window.open("https://www.instagram.com/centrikarw/", "_blank")
              }
            >
              <Instagram />
            </IconButton>
          </div>{" "}
        </Grid>
      </Grid>
    </Box>
  );
}

export default Footer;
